import React, { useState } from "react";
import TextInput from "../../../../components/textInput";
import AlertDialog from "../../../../components/alertDialog";
import i18n from "~/i18n";

export default function RenameChannelDialog({
  channel,
  isOpen,
  onSubmit,
  ...rest
}) {
  const [newName, setNewName] = useState(channel?.name);
  const [submitting, setSubmitting] = useState(false);
  const [formErrors, setFormErrors] = useState(null);

  async function handleSubmit() {
    setSubmitting(true);

    try {
      await validateForm();
      await onSubmit({
        ...channel,
        name: newName,
      });
    } finally {
      setSubmitting(false);
    }
  }

  async function validateForm() {
    try {
      if (newName.trim().length === 0) {
        throw i18n.t("chat:settings.channels.renameDialog.required")
      }

      setFormErrors(null);
    } catch (error) {
      setFormErrors({ newName: error });
      throw error;
    }
  }

  return (
    <AlertDialog
      open={isOpen}
      title={i18n.t("chat:settings.channels.renameDialog.header")}
      ctaText={i18n.t("chat:settings.channels.renameDialog.button")}
      ctaVariant="primary"
      submitting={submitting}
      onCtaClick={handleSubmit}
      {...rest}
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}
      >
        <TextInput
          label={i18n.t("chat:settings.channels.renameDialog.name")}
          value={newName}
          disabled={submitting}
          // Issue with autofocus when opening dialog from a dropdown https://github.com/radix-ui/primitives/issues/1615
          autoFocus
          onChange={(e) => setNewName(e.target.value)}
          error={formErrors?.newName}
          maxlength={100}
        />
      </form>
    </AlertDialog>
  );
}
